"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OntoWalletConnector = void 0;
const Errors_1 = require("../../Errors");
const ethers_1 = require("ethers");
const BaseConnector_1 = require("../BaseConnector");
const Web3BaseAdapter_1 = require("../../Adapters/Web3BaseAdapter");
const Adapters_1 = require("../../Adapters");
const Types_1 = require("../../Types");
class OntoWalletConnector extends BaseConnector_1.BaseConnector {
    constructor(config, metadata = {
        name: Types_1.WalletConnectors.OntoWallet,
        displayName: "OntoWallet",
        isWallet: true,
    }) {
        super(metadata, config);
    }
    _connect() {
        return __awaiter(this, void 0, void 0, function* () {
            const ethAgent = this.getAgent();
            if (!(yield this.isAvailable())) {
                throw new Errors_1.WalletNotDetectedError(this.metadata.name);
            }
            const accounts = yield ethAgent.request({
                method: "eth_requestAccounts",
            });
            const address = ethers_1.ethers.utils.getAddress(accounts[0]);
            const provider = new ethers_1.ethers.providers.Web3Provider(ethAgent);
            const { chainId } = yield provider.getNetwork();
            const chainIdStr = `${chainId}`;
            const adapter = new Web3BaseAdapter_1.Web3BaseAdapter(this.config);
            adapter.setAddress(address);
            adapter.setProvider(provider);
            const multicall = new Adapters_1.Web3MulticallAdapter(adapter);
            this.initEventController(adapter);
            const isValidNetwork = yield adapter.isValidNetwork(chainIdStr);
            if (!isValidNetwork) {
                throw new Errors_1.InvalidNetworkError(chainIdStr);
            }
            return { adapter, multicall };
        });
    }
    isAvailable() {
        return __awaiter(this, void 0, void 0, function* () {
            return !!this.getAgent();
        });
    }
    getAgent() {
        var _a, _b;
        return ((_a = window.onto) !== null && _a !== void 0 ? _a : (((_b = window.ethereum) === null || _b === void 0 ? void 0 : _b.isONTO) && window.ethereum));
    }
    initEventController(adapter) {
        return __awaiter(this, void 0, void 0, function* () {
            this.getAgent().on("accountsChanged", ([address]) => {
                adapter.setAddress(address);
                this.emitter.emit("AddressChanged", address);
            });
        });
    }
}
exports.OntoWalletConnector = OntoWalletConnector;
